<template>
  <div>
    <h1>{{ $t("vehicleList.title") }}</h1>
    <delegation-info-menu />

    <vehicle-list />
  </div>
</template>

<script>
import DelegationInfoMenu from "../../components/DelegationInfoMenu.vue";
import VehicleList from "../../components/Settings/Vehicles/VehicleList.vue";

export default {
  name: "DelegationInfoVehicleView",
  components: { VehicleList, DelegationInfoMenu },
  data: () => ({}),
  computed: {
    hasPermissionForEdit() {
      return this.$store.getters.hasPermission("manageVehicles");
    }
  }
};
</script>

<style scoped></style>
